import {
  createContext,
  useContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from "react";

export type ProjectManagementTabId =
  | "planning"
  | "execution"
  | "validation"
  | "reporting"
  | "team"
  | "finance";

type ProviderSummary = {
  id: number | string;
  location: string;
  name: string;
  modules: string[];
  raw: Record<string, any>;
} | null;

export type ProjectManagementContextValue = {
  activeTab: ProjectManagementTabId;
  handleNewProject: () => void;
  handleSaveBaseline: () => void | Promise<void>;
  handleSaveBaselineDraft?: () => void | Promise<void>;
  handleFinalizeBaseline?: () => void | Promise<void>;
  permissions: string[];
  selectedProvider: ProviderSummary;
  setActiveTab: Dispatch<SetStateAction<ProjectManagementTabId>>;
  setIsHistoryModalOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedProvider: Dispatch<SetStateAction<any>>;
  userRole: string;
  isBaselineLocked?: boolean;
  [key: string]: any;
};

const ProjectManagementContext =
  createContext<ProjectManagementContextValue | null>(null);

type ProjectManagementProviderProps = {
  children: ReactNode;
  value: ProjectManagementContextValue;
};

export const ProjectManagementProvider = ({
  children,
  value,
}: ProjectManagementProviderProps) => {
  return (
    <ProjectManagementContext.Provider value={value}>
      {children}
    </ProjectManagementContext.Provider>
  );
};

export const useProjectManagementContext = () => {
  const context = useContext(ProjectManagementContext);

  if (!context) {
    throw new Error(
      "useProjectManagementContext must be used inside ProjectManagementProvider",
    );
  }

  return context;
};


